export default __webpack_public_path__ + "static/media/map.37f5c6cd.jpg";